import AccountDelete from './AccountDelete';
export type { AccountDeleteFormFields } from './AccountDelete.types';

export default AccountDelete;
